
import React, { useContext, useEffect } from "react";
import { BoxFC } from "components/BoxCustom";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { UserContext } from "contexts/UserContext";
import { loadMSData } from "utils";
import { Box } from "@mui/system";
import { Switch } from "react-router-dom";
import { Route } from "react-router-dom";
import { Redirect } from "react-router-dom";
import Loading from "components/Loading";
import { Container, AppBar } from 'components/appBarStyle'
import DesktopToolbar from "./DesktopToolbar";
import dayjs from "dayjs";
import SubcontractJobOrder from "pages/Menu1/SubcontractJobOrder/SubcontractJobOrder";
import SubcontractInvoice from "pages/Menu3/SubcontractInvoice/SubcontractInvoice";

const menuData = [
  { path: "/subcontract/ActiveJobOrder", label: "งานปัจจุบัน" },
  { path: "/subcontract/InvoiceManagement", label: "จัดการใบแจ้งหนี้" },
]
const SubContractLayout = () => {

  const { setUser } = useContext(UserContext);
  const { isLoading, ax, msData, setMSData } = useContext(GlobalStateContext);

  useEffect(() => {
    loadMSData(ax, setMSData, setUser)
  }, [setMSData, setUser, ax])

  useEffect(() => {
    dayjs.locale('en')
  }, [])

  return (

    msData &&
    <BoxFC>
      <AppBar position="fixed">
        <DesktopToolbar menuData={menuData} />
      </AppBar>
      <Container>
        <Box component="main" height="100%" width="100%" sx={{ p: 1, mt: 1 }}>
          <Switch>
            <Route path={`/subcontract/ActiveJobOrder`}><SubcontractJobOrder /></Route>
            <Route path={`/subcontract/InvoiceManagement`}><SubcontractInvoice /></Route>
            <Route path={`*`}><Redirect to="/404" /></Route>
          </Switch>
        </Box>
      </Container>
      {
        isLoading && <Loading />
      }
    </BoxFC>
  )
}

export default SubContractLayout